import React, { useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import "./signature.css"; // Import the CSS file for styling
import { showToast } from "../../util/toastHelper";
import { ToastContainer } from "react-toastify";

/**
 * React component for capturing digital signatures
 *
 * This component provides a canvas for capturing digital signatures and
 * notifies the parent component when the user has drawn a signature.
 *
 * @param {Object} props - Component props
 * @param {Function} [props.onSaveSignature] - Function to call when the user
 *    has drawn a signature
 * @param {Function} [props.onClearCanvas] - Function to call when the user
 *    clears the signature
 * @param {String} [props.errorMessage] - Error message to show if the user
 *    attempts to save the signature without drawing one
 */
const DigitalSignature = ({
  onSaveSignature,
  onClearCanvas,
  errorMessage = "Please provide a signature before saving.",
}) => {
  /**
   * Reference to the signature canvas element
   */
  const signaturePad = useRef(null);

  /**
   * State variable to track whether the user has drawn a signature
   */
  const [isAddedSignature, setIsAddedSignature] = useState(null);

  /**
   * Function to clear the signature
   * @param {Event} e event object
   */
  const clearSignature = (e) => {
    e.preventDefault();
    // Clear the signature from the canvas
    signaturePad.current.clear();
    // Call the onClearCanvas function to notify the parent component
    onClearCanvas();
    // Set isAddedSignature to false as the signature is no longer available
    setIsAddedSignature(false);
  };

  /**
   * Function to save the signature image
   * @param {Event} e event object
   */
  const saveSignature = (e) => {
    e.preventDefault();
    // Check if the signature is empty
    if (signaturePad.current.isEmpty()) {
      // Show an error message if the signature is empty
      showToast("error", errorMessage);
      return;
    }
    // Get the data URL of the signature
    const dataUrl = signaturePad.current.toDataURL();
    // Call the onSaveSignature function to notify the parent component
    onSaveSignature(dataUrl);
    // Set isAddedSignature to true as the signature is now available
    setIsAddedSignature(true);
  };

  /**
   * Handle signature drawing completion
   *
   * This function is called whenever the user stops drawing on the signature
   * canvas. If the user has drawn a signature, it is saved and the parent
   * component is notified.
   */
  const handleSignatureChange = () => {
    // Check if the user has drawn a signature
    if (!signaturePad.current.isEmpty()) {
      // Get the base64 encoded string representation of the signature
      // const singatureBase64String = signaturePad.current.toDataURL();
      // Call the onSaveSignature function to notify the parent component
      // onSaveSignature(singatureBase64String);
      // Set isAddedSignature to true as the signature is now available
      setIsAddedSignature(true);
    }
  };

  return (
    <>
      <div className="signature-container">
        <h3>Sign Here</h3>
        <SignatureCanvas
          ref={signaturePad}
          penColor="black"
          backgroundColor="white"
          canvasProps={{
            width: 500,
            height: 200,
            className: "signature-canvas",
          }}
          onEnd={handleSignatureChange}
        />
        <div>
          {isAddedSignature && (
            <>
              <button className="clear-btn" onClick={clearSignature}>
                Clear signature
              </button>
              <button className="save-btn" onClick={saveSignature}>
                Save signature
              </button>
            </>
          )}

         
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default DigitalSignature;
